var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnlinePayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 228,
    viewBox: "0 0 228 228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 228,
    height: 228,
    rx: 35,
    fill: "#00B8E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152.698 79.1017C158.078 88.0978 160.377 98.625 159.242 109.065V115.058C159.234 121.368 160.876 127.568 164 133.036M87.8646 103.073C87.8646 96.7151 90.3712 90.618 94.8331 86.1226C99.2951 81.6272 105.347 79.1017 111.657 79.1017C117.967 79.1017 124.019 81.6272 128.481 86.1226C132.942 90.618 135.449 96.7151 135.449 103.073V109.065C135.449 122.032 139.623 134.649 147.346 145.022M111.657 103.073V115.058C111.638 132.194 116.827 148.924 126.527 163M87.8646 127.044C89.3201 139.567 92.9438 151.737 98.5711 163M69.4255 151.014C65.412 137.413 63.6043 123.248 64.0722 109.065V103.073C64.0494 94.646 66.2315 86.3622 70.3986 79.0558C74.5658 71.7496 80.5706 65.679 87.8083 61.4557C95.0459 57.2324 103.261 55.0057 111.624 55C119.988 54.9943 128.206 57.2097 135.45 61.4231",
    stroke: "white",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlinePayment);
export default __webpack_public_path__ + "static/media/OnlinePayment.16867ba08326502dd6b2bf24238be0a4.svg";
export { ForwardRef as ReactComponent };